import React from 'react';
import StaticPage from '../components/layout/StaticPage';

export default function PrivacyPolicy() {
    return (
        <StaticPage title="Privacy Policy">
            <div className="space-y-8 text-sm md:text-base text-gray-700">
                <p className="text-gray-500 text-sm italic">Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">1. Information We Collect</h3>
                    <p>We collect information to provide and improve our marketplace and event planning services:</p>
                    <ul className="list-disc list-inside mt-2 ml-2 space-y-1">
                        <li><strong>Account Information:</strong> Name, email address, phone number, and profile pictures (stored securely via Google Firebase).</li>
                        <li><strong>Transaction Data:</strong> Booking details, rental dates, and payment history. Payment processing is handled by Stripe; we do <strong>not</strong> store full credit card numbers on our servers.</li>
                        <li><strong>Event & Guest Data:</strong> Guest lists, RSVPs, dietary restrictions, and event locations provided by hosts.</li>
                        <li><strong>Location Data:</strong> Addresses entered for deliveries or venues, and approximate location data derived from IP addresses (processed via Google Maps API).</li>
                        <li><strong>Communications:</strong> Messages sent between users on our platform, and support inquiries.</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">2. How We Use Your Information</h3>
                    <ul className="list-disc list-inside space-y-2 ml-2">
                        <li>To facilitate rental bookings, coordinate deliveries, and manage event schedules.</li>
                        <li>To process payments, subscriptions, and payouts via Stripe.</li>
                        <li>To send transactional SMS and emails (e.g., booking confirmations, E-vites, reminders).</li>
                        <li>To provide AI-powered recommendations by processing anonymized event descriptions through Google Gemini.</li>
                        <li>To improve platform security, enforce our Terms of Service, and prevent fraud.</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">3. Mobile Data & SMS Privacy (CTIA Compliance)</h3>
                    <p>We respect your privacy regarding mobile communications. When you provide a phone number for SMS notifications or E-vites:</p>
                    <ul className="list-disc list-inside mt-2 ml-2 space-y-1">
                        <li><strong>No Sale of Phone Numbers:</strong> Your mobile information will <strong>never</strong> be shared with third parties or affiliates for marketing or promotional purposes.</li>
                        <li>All other categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.</li>
                        <li>SMS data is only shared with our direct communication service providers (e.g., Brevo/Twilio) strictly for the purpose of delivering the requested transactional messages.</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">4. Third-Party Technologies & Data Sharing</h3>
                    <p>We share data with trusted third-party service providers solely to operate our Platform:</p>
                    <ul className="list-disc list-inside mt-2 ml-2 space-y-1">
                        <li><strong>Google Firebase:</strong> For secure database hosting, storage, and authentication.</li>
                        <li><strong>Stripe:</strong> For payment processing, subscription management, and identity verification (KYC).</li>
                        <li><strong>Google Cloud (Gemini & Maps):</strong> For AI content generation and mapping/routing services.</li>
                        <li><strong>Brevo/Communication Partners:</strong> For routing emails and SMS messages.</li>
                    </ul>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">5. Cookies and Tracking</h3>
                    <p>We use local storage and cookies to:</p>
                    <ul className="list-disc list-inside mt-2 ml-2 space-y-1">
                        <li>Maintain your secure login session.</li>
                        <li>Remember your preferences (e.g., search filters, cookie consent choices).</li>
                        <li>Analyze site traffic to improve performance.</li>
                    </ul>
                    <p>You can manage your cookie preferences using the "Manage Preferences" option in our site's Cookie Banner, or through your browser settings.</p>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">6. Data Retention & User Rights</h3>
                    <p>We retain your personal information as long as your account is active or as needed to provide you services and comply with legal obligations.</p>
                    <p className="mt-2"><strong>Account Deletion:</strong> You may permanently delete your account and all associated data at any time by visiting your Account Settings and using the "Delete Account" function in the Danger Zone.</p>
                </section>

                <section>
                    <h3 className="text-xl font-bold text-gray-900 mb-3">7. Contact Us</h3>
                    <p>If you have questions about this Privacy Policy or our data practices, please contact us at:</p>
                    <p className="mt-2 font-medium">Cacti Interactive LLC<br/>Simi Valley, CA<br/><a href="mailto:support@cacti-interactive.com" className="text-pink-600 hover:underline">support@cacti-interactive.com</a></p>
                </section>
            </div>
        </StaticPage>
    );   
}
